export const translations = {
  en: {
    brand: { tagline: "Interior & Construction" },
    nav: { services: "Services", process: "Process", work: "Work", whyUs: "Why Us", reviews: "Reviews", contact: "Contact" },
    hero: {
      greeting: "नमस्ते, आपका स्वागत है",
      eyebrow: "Turnkey Interior & Construction",
      headlineA: "One team. ",
      headlineB: "Design to handover.",
      sub: "The Build and Design is a full turnkey interior and construction company — a single team takes your project from first sketch to final handover, with fixed timelines, transparent pricing, and quality work delivered on time. We serve homes and businesses everywhere.",
      cta: "Request a Quote",
      work: "See Our Work",
    },
    services: {
      eyebrow: "What We Do",
      heading: "Everything your space needs, from one team",
      items: [
        { title: "Turnkey Interiors", desc: "Complete home interiors handled end to end — design, materials, execution and handover, all under one roof." },
        { title: "Construction", desc: "Ground-up construction with a single accountable team, fixed timelines and transparent pricing at every stage." },
        { title: "Renovation", desc: "Transforming existing spaces — kitchens, living areas and full homes — with quality work delivered on time." },
        { title: "Office & Shop Interiors", desc: "Commercial interiors for offices and retail spaces, designed to impress clients and built to last." },
      ],
    },
    process: {
      eyebrow: "How It Works",
      heading: "From first sketch to final key",
      steps: [
        { title: "Design", desc: "We listen, measure and sketch — layouts, materials and finishes tailored to your space and budget." },
        { title: "Quote", desc: "A fixed timeline and transparent pricing, agreed before a single wall is touched. No surprises later." },
        { title: "Build", desc: "Our own team executes — civil work, carpentry, electrical, painting — with quality checks at every stage." },
        { title: "Handover", desc: "On-time delivery of a finished, move-in-ready space. One team, one point of contact, start to finish." },
      ],
    },
    whyUs: {
      eyebrow: "Why Clients Choose Us",
      heading: "The turnkey difference",
      points: [
        { title: "Full Turnkey Service", desc: "One team from design to handover — you never chase multiple contractors again." },
        { title: "Fixed Timeline", desc: "Your completion date is agreed up front, and we plan every stage around it." },
        { title: "Transparent Pricing", desc: "Clear, itemised quotes before work begins. What we quote is what you pay." },
        { title: "Quality, On Time", desc: "Quality work and on-time delivery — the two promises our clients remember us for." },
      ],
    },
    portfolio: {
      eyebrow: "Our Work",
      heading: "Spaces we design and build",
      sub: "Real work from The Build and Design — bedrooms, kitchens, dining spaces and entrances designed and built by our own team.",
      labels: ["Bedroom Interiors", "Bedroom Design", "Modular Kitchen — Indira Nagar", "4BHK Villa — Sushant Golf City", "Balcony & Swing", "Living Room — Gomti Nagar", "Master Suite — Gomti Nagar Ext", "Renovation — Mahanagar", "Office & Study"],
    },
    contact: {
      eyebrow: "Get In Touch",
      heading: "Let's build your space",
      intro: "Tell us what you need — a home interior, a new build, a renovation or an office fit-out. We travel anywhere and every enquiry starts with a free conversation.",
      nameLabel: "Your Name *",
      phoneLabel: "Phone Number *",
      serviceLabel: "What do you need? *",
      messageLabel: "Tell us more",
      namePh: "Full name",
      phonePh: "Your phone number",
      messagePh: "Location, size of the space, timeline — anything that helps",
      selectService: "Select a service",
      options: [
        { value: "Turnkey Interiors", label: "Turnkey Interiors" },
        { value: "Construction", label: "Construction" },
        { value: "Renovation", label: "Renovation" },
        { value: "Office / Shop Interiors", label: "Office / Shop Interiors" },
        { value: "Free Site Visit", label: "Free Site Visit" },
      ],
      siteVisit: "I'd like to book a free site visit",
      submit: "Send Enquiry",
      sending: "Sending...",
      directions: "Get Directions",
      toastRequired: "Please fill in your name, phone and service.",
      toastSuccess: "Thank you! Your enquiry is saved — we will call you back shortly.",
      toastError: "Something went wrong. Please try calling us instead.",
      thanksHindi: "धन्यवाद!",
      thanksTitle: "Thank you for your enquiry",
      thanksBody: "We have received your details. Abhay Rai from The Build and Design will call you back shortly on your number. For anything urgent, reach us right away:",
      thanksCall: "Call",
      thanksAnother: "Send Another Enquiry",
    },
    footer: {
      blurb: "A turnkey interior and construction company. One team from design to handover — for homes and businesses, wherever you are.",
      services: "Services",
      contact: "Contact",
      whatsapp: "Chat on WhatsApp",
      bottom: "The Build and Design — Interior & Construction",
    },
    welcome: { tagline: "Interior & Construction — Design to Handover" },
    reviews: {
      eyebrow: "Client Reviews",
      heading: "What our clients say",
      sub: "Real feedback from families and businesses whose spaces we designed and built.",
      writeBtn: "Share Your Review",
      formTitle: "Share your experience",
      nameLabel: "Your Name *",
      namePh: "Full name",
      projectLabel: "Project / Locality",
      projectPh: "e.g. 3BHK interiors, Gomti Nagar",
      ratingLabel: "Rating *",
      textLabel: "Your Review *",
      textPh: "How was our work, timeline and team?",
      submit: "Submit Review",
      sending: "Sending...",
      toastRequired: "Please fill in your name and review.",
      pickRating: "Tap a number from 1 to 5 to rate your experience",
      levels: ["Needs a lot of work", "Below expectations", "Good — met the basics", "Very good work", "Exceptional — premium finish"],
      toastSuccess: "Thank you! Your review will appear after approval.",
      toastError: "Something went wrong. Please try again.",
      empty: "No reviews yet — be the first to share your experience!",
    },
    aria: { whatsapp: "Chat on WhatsApp", call: "Call us", closeWelcome: "Close welcome", toggleMenu: "Toggle menu" },
  },
  hi: {
    brand: { tagline: "इंटीरियर और कंस्ट्रक्शन" },
    nav: { services: "सेवाएँ", process: "प्रक्रिया", work: "हमारा काम", whyUs: "हमें क्यों चुनें", reviews: "समीक्षाएँ", contact: "संपर्क करें" },
    hero: {
      greeting: "नमस्ते, आपका स्वागत है",
      eyebrow: "टर्नकी इंटीरियर और कंस्ट्रक्शन",
      headlineA: "एक टीम — ",
      headlineB: "डिज़ाइन से हैंडओवर तक।",
      sub: "द बिल्ड एंड डिज़ाइन एक फुल टर्नकी इंटीरियर और कंस्ट्रक्शन कंपनी है — एक ही टीम आपके प्रोजेक्ट को पहले स्केच से आखिरी हैंडओवर तक संभालती है। तय समय-सीमा, पारदर्शी कीमत और गुणवत्तापूर्ण काम, समय पर। हम हर जगह घरों और दुकानों के लिए काम करते हैं।",
      cta: "कोटेशन माँगें",
      work: "हमारा काम देखें",
    },
    services: {
      eyebrow: "हम क्या करते हैं",
      heading: "आपकी जगह की हर ज़रूरत, एक ही टीम से",
      items: [
        { title: "टर्नकी इंटीरियर", desc: "घर के पूरे इंटीरियर का काम शुरू से अंत तक — डिज़ाइन, सामान, काम और हैंडओवर, सब एक छत के नीचे।" },
        { title: "कंस्ट्रक्शन", desc: "शुरू से अंत तक निर्माण — एक जिम्मेदार टीम, हर चरण में तय समय-सीमा और पारदर्शी कीमत।" },
        { title: "रेनोवेशन", desc: "पुरानी जगहों को नया रूप — किचन, लिविंग एरिया या पूरा घर — गुणवत्तापूर्ण काम, समय पर डिलीवरी।" },
        { title: "ऑफिस और दुकान के इंटीरियर", desc: "ऑफिस और दुकानों के कमर्शियल इंटीरियर — ग्राहकों को प्रभावित करने वाला डिज़ाइन, मज़बूत निर्माण।" },
      ],
    },
    process: {
      eyebrow: "काम करने का तरीका",
      heading: "पहले स्केच से आखिरी चाबी तक",
      steps: [
        { title: "डिज़ाइन", desc: "हम आपकी बात सुनते हैं, नाप लेते हैं और स्केच बनाते हैं — आपकी जगह और बजट के हिसाब से लेआउट, सामान और फिनिश।" },
        { title: "कोटेशन", desc: "तय समय-सीमा और पारदर्शी कीमत, काम शुरू होने से पहले ही तय। बाद में कोई छिपा खर्च नहीं।" },
        { title: "निर्माण", desc: "हमारी अपनी टीम काम करती है — सिविल, कारपेंटरी, बिजली, पेंटिंग — हर चरण पर क्वालिटी चेक।" },
        { title: "हैंडओवर", desc: "समय पर तैयार, रहने लायक जगह की डिलीवरी। शुरू से अंत तक एक टीम, एक संपर्क।" },
      ],
    },
    whyUs: {
      eyebrow: "ग्राहक हमें क्यों चुनते हैं",
      heading: "टर्नकी का फ़र्क़",
      points: [
        { title: "फुल टर्नकी सर्विस", desc: "डिज़ाइन से हैंडओवर तक एक टीम — अलग-अलग ठेकेदारों के पीछे भागने की ज़रूरत नहीं।" },
        { title: "तय समय-सीमा", desc: "काम पूरा होने की तारीख पहले से तय, और हर चरण की योजना उसी के हिसाब से।" },
        { title: "पारदर्शी कीमत", desc: "काम शुरू होने से पहले साफ़, आइटम-वार कोट। जितना बताया, उतना ही बिल।" },
        { title: "क्वालिटी, समय पर", desc: "गुणवत्तापूर्ण काम और समय पर डिलीवरी — यही दो वादे हमारे ग्राहक याद रखते हैं।" },
      ],
    },
    portfolio: {
      eyebrow: "हमारा काम",
      heading: "जगहें जो हम डिज़ाइन और बनाते हैं",
      sub: "द बिल्ड एंड डिज़ाइन का असली काम — बेडरूम, किचन, डाइनिंग और एंट्रेंस, हमारी अपनी टीम द्वारा डिज़ाइन और निर्मित।",
      labels: ["बेडरूम इंटीरियर", "बेडरूम डिज़ाइन", "मॉड्यूलर किचन — इंदिरा नगर", "4BHK विला — सुशांत गोल्फ सिटी", "बालकनी और झूला", "लिविंग रूम — गोमती नगर", "मास्टर सूट — गोमती नगर एक्सटेंशन", "रेनोवेशन — महानगर", "ऑफिस और स्टडी"],
    },
    contact: {
      eyebrow: "संपर्क करें",
      heading: "आइए आपकी जगह बनाते हैं",
      intro: "बताइए आपको क्या चाहिए — घर का इंटीरियर, नया निर्माण, रेनोवेशन या ऑफिस का काम। हम कहीं भी जाते हैं और हर एंक्वायरी मुफ्त बातचीत से शुरू होती है।",
      nameLabel: "आपका नाम *",
      phoneLabel: "फ़ोन नंबर *",
      serviceLabel: "आपको क्या चाहिए? *",
      messageLabel: "और बताइए",
      namePh: "पूरा नाम",
      phonePh: "आपका फ़ोन नंबर",
      messagePh: "जगह, साइज़, समय — जो भी मदद करे",
      selectService: "सेवा चुनें",
      options: [
        { value: "Turnkey Interiors", label: "टर्नकी इंटीरियर" },
        { value: "Construction", label: "कंस्ट्रक्शन" },
        { value: "Renovation", label: "रेनोवेशन" },
        { value: "Office / Shop Interiors", label: "ऑफिस / दुकान इंटीरियर" },
        { value: "Free Site Visit", label: "मुफ्त साइट विज़िट" },
      ],
      siteVisit: "मैं मुफ्त साइट विज़िट बुक करना चाहता/चाहती हूँ",
      submit: "एंक्वायरी भेजें",
      sending: "भेजा जा रहा है...",
      directions: "रास्ता देखें",
      toastRequired: "कृपया अपना नाम, फ़ोन और सेवा भरें।",
      toastSuccess: "धन्यवाद! आपकी एंक्वायरी सेव हो गई — हम जल्द ही आपको कॉल करेंगे।",
      toastError: "कुछ गड़बड़ हो गई। कृपया हमें कॉल करें।",
      thanksHindi: "धन्यवाद!",
      thanksTitle: "आपकी एंक्वायरी के लिए धन्यवाद",
      thanksBody: "हमें आपकी जानकारी मिल गई है। द बिल्ड एंड डिज़ाइन से अभय राय जल्द ही आपके नंबर पर कॉल करेंगे। ज़रूरी काम के लिए अभी संपर्क करें:",
      thanksCall: "कॉल करें",
      thanksAnother: "एक और एंक्वायरी भेजें",
    },
    footer: {
      blurb: "एक टर्नकी इंटीरियर और कंस्ट्रक्शन कंपनी। डिज़ाइन से हैंडओवर तक एक टीम — घरों और दुकानों के लिए, आप जहाँ भी हों।",
      services: "सेवाएँ",
      contact: "संपर्क",
      whatsapp: "WhatsApp पर चैट करें",
      bottom: "द बिल्ड एंड डिज़ाइन — इंटीरियर और कंस्ट्रक्शन",
    },
    welcome: { tagline: "इंटीरियर और कंस्ट्रक्शन — डिज़ाइन से हैंडओवर तक" },
    reviews: {
      eyebrow: "ग्राहकों की राय",
      heading: "हमारे ग्राहक क्या कहते हैं",
      sub: "जिन परिवारों और दुकानों की जगह हमने डिज़ाइन और बनाई, उनकी असली राय।",
      writeBtn: "अपनी समीक्षा लिखें",
      formTitle: "अपना अनुभव साझा करें",
      nameLabel: "आपका नाम *",
      namePh: "पूरा नाम",
      projectLabel: "प्रोजेक्ट / इलाका",
      projectPh: "जैसे: 3BHK इंटीरियर, गोमती नगर",
      ratingLabel: "रेटिंग *",
      textLabel: "आपकी समीक्षा *",
      textPh: "हमारा काम, समय-सीमा और टीम कैसी लगी?",
      submit: "समीक्षा भेजें",
      sending: "भेजा जा रहा है...",
      toastRequired: "कृपया अपना नाम और समीक्षा भरें।",
      pickRating: "अपना अनुभव रेट करने के लिए 1 से 5 तक का नंबर चुनें",
      levels: ["बहुत सुधार की ज़रूरत", "उम्मीद से कम", "अच्छा — उम्मीद के मुताबिक", "बहुत अच्छा काम", "शानदार — प्रीमियम फिनिश"],
      toastSuccess: "धन्यवाद! आपकी समीक्षा जाँच के बाद दिखाई जाएगी।",
      toastError: "कुछ गड़बड़ हो गई। कृपया फिर कोशिश करें।",
      empty: "अभी कोई समीक्षा नहीं — सबसे पहले अपना अनुभव साझा करें!",
    },
    aria: { whatsapp: "WhatsApp पर चैट करें", call: "हमें कॉल करें", closeWelcome: "वेलकम बंद करें", toggleMenu: "मेनू खोलें या बंद करें" },
  },
};
